import React from 'react';

const PrivacyPolicy = () => {
	return (
		<section>
			<div>
				<div id='privacy-content'>
					<p>This Privacy Policy is effective as of January 1, 2023</p>
					<p>
						The following policies are in effect for the domains, sub-domains
						and Web pages owned and operated by Sempris, and/or its subsidiaries
						and affiliates (collectively, “Sempris”). The Sempris network
						includes numerous subscription marketing websites and our corporate
						website located at{' '}
						<a href='https://www.sempris.com/' target='blank'>
							www.sempris.com
						</a>{' '}
						(the “Sites”). This Privacy Policy applies with respect to the
						collection and processing of information related to the Sites, our
						business contacts, and the subscription programs we offer through
						the Sites. By using any of the Sites or becoming a customer of one
						of our Sites (“Customer”), you signify that you have read and
						understand this Sempris Privacy Policy (“Privacy Policy”).
					</p>
					<p>
						Sempris’ Privacy Policy is designed to help you understand how we
						collect and use the personal information you decide to share, and
						help you make informed decisions. We reserve the right, at our sole
						discretion, to change, modify, add, or delete portions of this
						Privacy Policy at any time. It is your responsibility to regularly
						review this Privacy Policy. If you have any questions concerning
						this Privacy Policy, please contact us at{' '}
						<a href='mailto:privacy@sempris.com'>privacy@sempris.com</a>.
					</p>
					<p>WHAT INFORMATION DO WE COLLECT?</p>
					<p>
						Information You Provide. We collect information when you provide it
						to us. For example, when you register as a Customer, we will collect
						and store personal information, including your name, address, e-mail
						address, telephone number, and other information from which your
						identity is or may be discernible. We will also collect and store
						payment information, which may include credit card number and
						billing address. We also collect information when you call one of
						our call centers. We will collect similar information from you as a
						business contact when you interact with Sempris, such as by
						purchasing our services for your company.
					</p>
					<p>
						For Customers, we may also collect and store statistical and
						demographic information that does not directly identify you such as
						ZIP code, age, gender, and interests.
					</p>
					<p>
						Information Collected Automatically. We also automatically gather or
						may gather certain information about your use of our Sites, such as
						what areas you visit and what services you use. Moreover, we may
						obtain information about your computer hardware and software that
						can include, without limitation, IP address, browser type, domain
						names, access times, and referring website addresses.
					</p>
					<p>
						Information From Third Parties. We obtain certain information from
						third parties, including third parties that provide services to us.
						For example, when you call one of our call centers, we will obtain
						information from that call center. We also obtain information from
						resellers of commercial transaction data, from direct mail service
						bureaus, and from government entities such as the United States
						Postal Service.
					</p>
					<p>
						We may combine the information from any and all of the above sources
						and use it as described below.
					</p>
					<p>USE OF INFORMATION</p>
					<p>
						Sempris collects and processes the information described above for
						any lawful purpose, including the following:
					</p>
					<ul>
						<li>
							To communicate with and manage our relationship with Customers,
							business partners, and others who correspond with us
						</li>
						<li>To administer subscription programs and benefits</li>
						<li>To provide, maintain, and improve our products and services</li>
						<li>
							To detect and take steps to protect against fraud, security
							incidents, and illegal activity
						</li>
						<li>
							To perform analysis for improving the Sites and to maintain the
							security of the Sites
						</li>
						<li>To conduct activities around customer satisfaction</li>
						<li>To receive feedback and handle requests or complaints</li>
						<li>
							To market our products and services and those of our business
							partners
						</li>
						<li>
							To send updates, promotions, and marketing materials that may be
							of interest to you
						</li>
						<li>
							To operate, personalize, and improve content on the Sites and how
							the Sites function
						</li>
						<li>To comply with law and</li>
						<li>
							With your consent, or as otherwise disclosed at the time data is
							collected
						</li>
					</ul>
					<p>SHARING AND DISCLOSURE OF INFORMATION WITH THIRD PARTIES</p>
					<p>
						Sempris may share your information with the following types of
						entities:
					</p>
					<ul>
						<li>
							Third parties for marketing purposes, including advertising
							companies and ad networks as well as third parties in a range of
							industries that provide products and services that may be of
							interest to you
						</li>
						<li>
							Service providers who provide services or functions on our behalf,
							including credit card processing, business analytics, customer
							service, marketing, distribution of surveys or sweepstakes
							programs, and fraud prevention
						</li>
						<li>
							Business partners with whom we may jointly offer subscription
							programs, products, or services
						</li>
						<li>
							Other related and/or affiliated companies within the Sempris
							network
						</li>
					</ul>
					<p>We also may share your information:</p>
					<ul>
						<li>
							In response to subpoenas, court orders, or other legal process; to
							establish or exercise our legal rights or those of our business
							partners; to bring or defend against legal claims; or as otherwise
							required by law. In such cases we reserve the right to raise or
							waive any legal objection or right available to us
						</li>
						<li>
							When we believe it is appropriate to investigate, prevent, or take
							action regarding illegal or suspected illegal activities; to
							protect and defend the rights, property, or safety of Sempris, our
							customers, or others; and in connection with our Terms of Service
							and other agreements
						</li>
						<li>
							In connection with an actual or potential corporate transaction,
							such as a divestiture, merger, consolidation, or asset sale, or in
							the unlikely event of bankruptcy
						</li>
						<li>
							With a partner that sponsors a promotion, sweepstakes or contest
							on one or more of the Sites
						</li>
						<li>With your consent or at your direction</li>
					</ul>
					<p>
						We also may share aggregate or anonymous information with third
						parties, including advertisers and investors. For example, we may
						tell our advertisers the number of visitors a particular Site
						receives or what the most popular discount offers are. This
						information does not contain any personal information and is used to
						develop content and services we hope you will find of interest.
					</p>
					<p>USE OF COOKIES</p>
					<p>
						Sempris uses “cookies” to help create a better and, for our
						Customers, a more personalized experience and to improve your
						experience, such as by helping our Sites “remember” you for an
						easier log-in experience. A cookie is a piece of data stored on the
						user’s computer. Your browser and other security applications can be
						set to prompt you when a website is setting a cookie or to reject
						all cookies. If you delete or reject all cookies, some Site sections
						and applications may not function properly or at all.
					</p>
					<p>
						Please note that Sempris allows third-party analytics providers and
						advertisers that are presenting advertisements on some of our pages
						to set and access their cookies on your computer. Analytics
						providers’ and advertisers’ use of cookies is subject to their own
						privacy policies, not the Sempris Privacy Policy.
					</p>
					<p>DIGITAL ANALYTICS AND INTEREST-BASED ADVERTISING</p>
					<p>
						We use Google Analytics to improve the performance of the Sites and
						for analytics and marketing purposes. For more information about how
						Google Analytics collects and uses data when you use the Sites,
						visit{' '}
						<a
							href='http://www.google.com/policies/privacy/partners'
							target='blank'
						>
							www.google.com/policies/privacy/partners
						</a>
						, and to opt out of Google Analytics, visit{' '}
						<a href='https://tools.google.com/dlpage/gaoptout' target='blank'>
							tools.google.com/dlpage/gaoptout
						</a>
						.
					</p>
					<p>
						We use other third-party service providers in order to better
						understand our Customers’ needs and to optimize our services. These
						service providers may use cookies and other technologies to collect
						data on our Customers’ activities and their devices. This includes a
						device’s IP address (processed during your session and stored in a
						de-identified form), device screen size, device type (unique device
						identifiers), browser information, geographic location (country
						only), and the preferred language used to display our website. These
						service providers may also store this information on Sempris’ behalf
						in a pseudonymized user profile.
					</p>
					<p>
						Rakuten Marketing may also collect personal information when you
						interact with our Sites, including IP addresses, digital
						identifiers, information about your web browsing and app usage and
						how you interact with our properties and ads for a variety of
						purpose, such as personalization of offers or advertisements,
						analytics about how you engage with websites or ads, and other
						commercial purposes. For more information about the collection, use
						and sale of your personal data and your rights, please use the below
						links.
					</p>
					<ul>
						<li>
							<strong>Company:</strong> Rakuten Marketing
						</li>
						<li>
							<strong>Privacy Policy:</strong>{' '}
							<a
								href='https://rakutenmarketing.com/legal-notices/services-privacy-policy/'
								target='blank'
							>
								https://rakutenmarketing.com/legal-notices/services-privacy-policy/
							</a>
						</li>
						<li>
							<strong>Your Rights:</strong>{' '}
							<a
								href='https://rakutenmarketing.com/legal-notices/subject-requests'
								target='blank'
							>
								https://rakutenmarketing.com/legal-notices/subject-requests
							</a>
						</li>
					</ul>
					<p id='ad-choices'>
						We may partner with Rakuten Marketing and other third-party ad
						networks and other ad service providers (collectively “Advertising
						Providers”) to serve ads on our behalf on non-affiliated third party
						sites. Some of those ads may be personalized, meaning that they are
						intended to be relevant to you based on information we or the
						Advertising Providers collect about your online activities here and
						elsewhere over time, including information about relationships among
						different browsers and devices. For example, information collected
						across multiple sites that you visit over time may enable the
						Advertising Provider to infer your preferences and show you ads that
						are more likely to be of interest to you. This type of advertising
						is known as interest-based advertising.
					</p>
					<p>ADCHOICES</p>
					<p>
						Sempris adheres to the Digital Advertising Alliance Self-Regulatory
						Principles in connection with this interest-based advertising
						activity. You may visit the DAA Webchoices tool at www.aboutads.info
						to learn more about this type of interest-based advertising and how
						to opt out of this advertising on websites by companies
						participating in the DAA self-regulatory program. If you delete your
						cookies or use a different browser or mobile device, you may need to
						renew your opt-out choices exercised through the DAA Webchoices
						tool. Note that electing to opt out will not stop advertising from
						appearing in your browser or applications. It may make the ads you
						see less relevant to your interests.
					</p>
					<p>
						In addition, you may visit the Network Advertising Initiative
						(“NAI”) for information about how to opt-out of interest-based
						advertising by NAI customers. See{' '}
						<a href='http://www.networkadvertising.org' target='blank'>
							http://www.networkadvertising.org
						</a>{' '}
						for general information about the NAI and{' '}
						<a href='http://optout.networkadvertising.org' target='blank'>
							http://optout.networkadvertising.org
						</a>{' '}
						for the opt-out page.
					</p>
					<p>SECURITY</p>
					<p>
						We use appropriate security measures designed to protect the
						information that we collect and process about you. Please note,
						however, that we cannot guarantee the security of information.
						Unauthorized entry or use, hardware or software failure, and other
						factors may compromise the security of user information at any time.
					</p>
					<p>CONTROL OF YOUR PASSWORD</p>
					<p>
						Site and Customer user accounts are secured by usernames and
						passwords. You are responsible for all actions taken with your login
						information and password. Therefore, you should not disclose your
						Sempris password or login information to any third parties. If you
						choose to share this information with third parties, you are
						responsible for all actions taken with your login information and
						password and therefore should review each third party’s privacy
						policy. If your password has been compromised for any reason, you
						should immediately change your password.
					</p>
					<p>YOUR EMAIL CHOICES</p>
					<p>
						You may unsubscribe from Sempris marketing email messages by
						following the instructions for unsubscribing in any such messages we
						send you, or you may unsubscribe from e-mail or other mail from us,
						by contacting us at: privacy@sempris.com. Please note that, if you
						unsubscribe from marketing emails, we may continue to send you other
						types of messages related to your transactions or relationship with
						Sempris.
					</p>
					<p>THIRD PARTY TOOLS AND LINKS</p>
					<p>
						The Sites may contain links to other websites. We are not
						responsible for the privacy policies and/or practices on other
						websites. When linking to another website we encourage our users to
						read the privacy policy stated on each and every website. This
						Privacy Policy only governs information collected on our Sites.
					</p>
					<p>
						The Sites may also include integrated social media tools or
						“plug-ins,” such as social networking tools offered by third
						parties. If you use these tools to share data or you otherwise
						interact with these features on the Sites, those companies may
						collect data about you and may use and share such information in
						accordance with your account settings, including by sharing such
						data with the general public.
					</p>
					<p>
						Your interactions with third-party companies and your use of their
						linked websites or integrated tools are governed by the privacy
						policies of the companies that provide those features. We encourage
						you to carefully read the privacy policies of any accounts you
						create and use.
					</p>
					<p>STATE PRIVACY RIGHTS</p>
					<p>
						California, Virginia, Colorado, Connecticut, Nevada, and Utah
						Customers and other consumers have certain rights under state
						privacy laws with respect to personal data subject to those laws.
						For our business contacts, only California residents have these
						rights for personal data that we have collected. This section
						contains disclosures required by state privacy laws and applies only
						to “personal information” or “personal data” that is subject to such
						laws. Consumers with disabilities may access this notice by calling
						800.475.1942 and one of our privacy experts will assist you with
						your request.
					</p>

					<p>
						<strong>
							Personal Information We Collect, Disclose for a Business Purpose,
							and Sell.
						</strong>{' '}
						We collected, disclosed for business purposes, and sold categories
						of personal information in the past 12 months as described in the{' '}
						<a
							href='/wp-content/uploads/2024/01/sempris-privacy_1.25.24.pdf'
							target='_blank'
							rel='noopener'
						>
							chart available here
						</a>
						, which contains certain information required under California law.
						Our purposes for collecting, using, and sharing personal information
						are also described in the chart.
					</p>
					<p>
						<strong>Your Rights Regarding Personal Information.</strong> You may
						have certain rights with respect to the personal information
						collected by Sempris. You may be able to exercise the following
						rights regarding personal information, subject to certain exceptions
						and limitations and depending on your state:
					</p>
					<ul>
						<li>
							The <strong>right to confirm</strong> whether we are processing
							personal data about you
						</li>
						<li>
							The <strong>right to correct inaccuracies</strong> in the personal
							data we have collected about you
						</li>
						<li>
							The <strong>right to know</strong> the categories and specific
							pieces of personal information we collect, use, disclose, and sell
							about you, the categories of sources from which we collected your
							personal information, our purposes for collecting or selling your
							personal information, the categories of your personal information
							that we have either sold or disclosed for a business purpose, and
							the categories of third parties with which we have shared personal
							information
						</li>
						<li>
							The <strong>right to request that we delete</strong> the personal
							information we have collected from you or maintain about you
						</li>
						<li>
							The <strong>right to opt out</strong> of (i) the sharing of
							personal data for targeted advertising and (ii) the sale of
							personal data. Please note that if you opt out of certain
							practices, we may be unable to provide you with some services
						</li>
						<li>
							Depending on your state, the{' '}
							<strong>
								right to limit our processing of certain “sensitive” personal
								data
							</strong>{' '}
							(or to withdraw consent for such processing if you previously gave
							it)
						</li>
						<li>
							The <strong>right not to receive discriminatory treatment</strong>{' '}
							for the exercise of the privacy rights conferred by state law
						</li>
					</ul>
					<p>
						The exercise of the above rights are subject to certain exceptions
						and limitations as permitted by law. For example, we may not delete
						certain personal information we collected from you if retaining the
						information is necessary for us to provide you with services or
						products that you have already purchased, to use the information in
						ways that are reasonably anticipated in the context of those
						transactions (e.g., to be able to answer questions about those
						transactions if you call our customer service line), or to comply
						with any applicable legal obligations.
					</p>
					<p>
						To exercise any of the above rights, please contact us using the
						following information and submit the required verifying information,
						as further described below:
					</p>
					<ul>
						<li>By phone at: 800.475.1942</li>
						<li>
							By email at:{' '}
							<a href='mailto:privacy@sempris.com'>privacy@sempris.com</a>
						</li>
						<li>
							Online at our{' '}
							<a href='/do-not-sell/' target='blank'>
								individual rights
							</a>{' '}
							request page
						</li>
						<li>
							You may also visit your subscription website and click on the link{' '}
							<a href='/do-not-sell/' target='blank'>
								“Do Not Sell or Share My Personal Information”
							</a>{' '}
							to access the rights described above
						</li>
					</ul>
					<p>
						For Virginia or Colorado residents, if you have submitted a request
						that you believe we have not fulfilled, you may contact us to appeal
						our decision by sending an email with the subject line “Appeal” to{' '}
						<a href='mailto:privacy@sempris.com'>privacy@sempris.com</a>.
					</p>
					<p>
						<strong>Verification Process and Required Information.</strong> For
						your protection, we may need to request additional information from
						you to verify your identity or understand the scope of your request,
						although you will not be required to create an account with us to
						submit a request or have it fulfilled. We may, depending on your
						specific request, require you to provide, at a minimum, two data
						elements which we will use to verify your identity.
					</p>
					<p>
						<strong>Authorized Agent.</strong> You may be able to designate an
						authorized agent to make a rights request on your behalf. In order
						to make the request, your authorized agent must visit the{' '}
						<a href='/do-not-sell/' target='blank'>
							individual rights
						</a>{' '}
						request page and follow the instructions as outlined on that
						webform.
					</p>
					<p>
						<strong>Minors’ Right to Opt In.</strong> We do not knowingly sell
						the personal information of minors under 16 years of age.
					</p>
					<p>
						<strong>Notice of Financial Incentive.</strong> In exchange for
						becoming a Customer of one or more of the Sites, we provide you with
						opportunities to receive benefits that may include, by way of
						example and depending on the Site, discounts on products and
						services, rewards, and rebates in exchange for purchasing a
						subscription and providing your contact information; providing
						information about your purchases; participating in promotions,
						contests or sweepstakes; and/or responding to surveys. Under certain
						state laws, because we offer you price or service differences
						related to the collection and sharing of personal information,
						subscription in a Sempris program is considered a “financial
						incentive.”
					</p>
					<p>
						You opt into these financial incentives by becoming a Customer. In
						connection with becoming a Customer, we collect and share personal
						information about you as described in this Privacy Policy. The terms
						associated with each Site if you join as a Customer are available in
						the{' '}
						<a href='/terms-conditions/' target='blank'>
							Subscription Terms
						</a>
						, and the benefits associated with subscription are listed within
						your Customer welcome materials or within the Site. You may opt into
						additional financial incentives by participating in certain
						promotions, contests, and sweepstakes and/or by completing surveys.
						The terms associated with a given promotion, contest, sweepstakes,
						or survey are provided alongside the opportunity to participate in
						that promotion, contest, sweepstakes, or survey.
					</p>
					<p>
						The amount of benefit you receive for becoming a Customer, providing
						information about your purchases, participating in contests or
						sweepstakes, and/or completing a survey is based on the reasonable
						determination of the value that we and our business partners receive
						from processing personal information. This estimated value takes
						into account a variety of factors as permitted by law, including
						(but not limited to) the expenses incurred in collecting and
						retaining the information, the expenses in administering the
						financial incentive programs, the expenses incurred in providing
						benefits to you, and the estimated marginal revenue derived from the
						information we and our partners obtain and use.
					</p>
					<p>
						You can withdraw from these financial incentives at any time by
						visiting{' '}
						<a
							href='https://www.programstop.com/'
							target='_blank'
							rel='noreferrer'
						>
							www.programstop.com
						</a>{' '}
						or calling 800.475.1942.
					</p>
					<p>CHANGES IN OUR PRIVACY POLICY</p>
					<p>
						From time to time we may make changes to our Privacy Policy. We
						reserve the right, at our sole discretion, to change, modify, add,
						or delete portions of this Privacy Policy at any time. If we do
						this, we will post the changes to this Privacy Policy on each of the
						applicable Sites, with the effective date of the policy indicated at
						the top of the page. We encourage you to visit this page
						periodically to learn of any updates. Your continued use of any of
						the Sites after any such change constitutes your acknowledgement of
						the new Privacy Policy.
					</p>
					<p>CONTACT US</p>
					<p>
						For questions or concerns about Sempris’ Privacy Policy or
						practices, please contact us by email us at{' '}
						<a href='mailto:privacy@sempris.com'>privacy@sempris.com</a> or call
						toll-free 800.475.1942 and one of our privacy experts will assist
						you with your request.
					</p>
					<p>
						Alternatively, you may also contact us using the information below.
					</p>
					<div>
						Sempris, LLC
						<br />
						P.O. Box 5265
						<br />
						Hopkins, MN 55343-1034
						<br />
						Attn: Privacy
					</div>
				</div>
			</div>
		</section>
	);
};

export default PrivacyPolicy;
